import { Button, IconButton, ListItemIcon, Menu, MenuItem, Typography, useTheme } from "@mui/material";
import { ReactNode, useState } from "react";
import { TOOLBAR_HEIGHT } from "./SecondaryToolbar";

export interface RobotStateAction {
  name: string;
  Icon: ReactNode;
  onClick: () => void;
  active: boolean;
  disabled?: boolean;
}


export interface RobotButtonProps {
  actions: RobotStateAction[];
  select?: boolean;
  id?: string;
  actionLabelLength?: number; // how many characters of the action name to show on the button when select is true
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | undefined;
}

export const BUTTON_MIN_WIDTH = 80;

export function RobotButton({ actions, select, id, actionLabelLength, color = 'success' }: RobotButtonProps) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleSelectClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    setTimeout(() => {
      handleSelectClose();
    }, 5000);
  };
  const handleSelectClose = () => {
    setAnchorEl(null);
  };
  const aa = actions.find(a => a.active);
  if (!aa) {
    console.error('no active action found for RobotButton', actions);
    return null;
  }
  actionLabelLength = actionLabelLength || 1;
  if (select) {
    return (
      <div style={{ display: 'inline-block', margin: '0', padding: '0' }}>
        <Button id={id}
          color={color}
          sx={{
            background: theme.palette.background.paper,
            height: TOOLBAR_HEIGHT - 16,
            minWidth: `${BUTTON_MIN_WIDTH}px`,
            textAlign: 'left',
            paddingLeft: '8px',
            paddingRight: '8px',
            borderRadius: '16px',
          }}
          variant="outlined"
          size="large"
          aria-controls={open ? `basic-menu-${id}` : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleSelectClick}
        >
          {aa.Icon} <Typography sx={{ paddingLeft: '8px' }} variant="h5">{aa.name.substring(0, actionLabelLength)}</Typography>
        </Button>
        <Menu
          id={`basic-menu-${id}`}
          anchorEl={anchorEl}
          open={open}
          onClose={handleSelectClose}
          slotProps={{
            list: {
              'aria-labelledby': id,
            },
          }}
        >
          {actions.map((action) => (
            <MenuItem key={action.name} onClick={() => { action.onClick(); handleSelectClose(); }} disabled={action.disabled}>
              <ListItemIcon sx={{ mr: '8px' }}>{action.Icon}</ListItemIcon>
              <Typography color={color} variant="h6">{action.name}</Typography>
            </MenuItem>
          ))}
        </Menu>
      </div>
    )
  } else {
    return (
      <Button
        onClick={aa.onClick}
        disabled={aa.disabled}
        size='large'
        color={color}
        sx={{
          background: theme.palette.background.paper,
          height: TOOLBAR_HEIGHT - 16,
          textAlign: 'left',
          paddingLeft: '8px',
          paddingRight: '8px',
          borderRadius: '16px',
          minWidth: `${BUTTON_MIN_WIDTH}px`,
        }}
      >
        {aa.Icon}
      </Button>
    );
  }
}